<template>
  <div class="admin-section-header d-flex flex-wrap align-items-start justify-content-between mb-1">
    <div class="d-flex align-items-start admin-section-header__main">
      <div
        v-if="icon"
        class="admin-section-header__icon rounded d-flex align-items-center justify-content-center flex-shrink-0"
      >
        <feather-icon :icon="icon" size="18" />
      </div>
      <div class="admin-section-header__text">
        <h5 v-if="title" class="admin-section-header__title mb-25">
          {{ title }}
        </h5>
        <p v-if="description" class="admin-section-header__desc text-muted mb-0">
          {{ description }}
        </p>
      </div>
    </div>
    <div v-if="$slots.actions" class="admin-section-header__actions d-flex flex-wrap align-items-center mt-25 mt-md-0">
      <slot name="actions" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminSectionHeader',
  props: {
    title: { type: String, default: '' },
    description: { type: String, default: '' },
    icon: { type: String, default: '' },
  },
}
</script>

<style scoped>
.admin-section-header__icon {
  width: 2.25rem;
  height: 2.25rem;
  margin-right: 0.75rem;
  background: rgba(115, 103, 240, 0.12);
  color: #7367f0;
}
.admin-section-header__title {
  font-size: 1.05rem;
  font-weight: 600;
  line-height: 1.3;
}
.admin-section-header__desc {
  font-size: 0.8125rem;
  line-height: 1.45;
  max-width: 42rem;
}
.admin-section-header__actions {
  gap: 0.35rem 0.5rem;
}
</style>
